import businessPortalClient from "../businessPortalClient";
import { AxiosResponse } from "axios";
import { OidcConfigurationResponseModel } from "../models/OidcConfigurationResponseModel";
import oidcApi from "../api/oidc.api";

type OidcService = {
  getConfiguration: () => Promise<AxiosResponse<OidcConfigurationResponseModel>>;
};

const getConfiguration = (): Promise<AxiosResponse<OidcConfigurationResponseModel>> =>
  businessPortalClient.get(oidcApi.getConfigurationUrl());

export default {
  getConfiguration,
} as OidcService;
